import React, { useState } from "react"
import { Card, Box, CardContent, Typography } from "@material-ui/core"
import { useDispatch } from "react-redux"
import moment from "moment"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateFlagStatusCrewClient } from "../../../../actions/billing-crew-client"
import { toggleFlaggingDialog } from "../../../../actions/billingDialogs"
import { _toggleLoginDialog } from "../../../../actions/authentication"
import PropTypes from "prop-types"
import {
  columns,
  crewMobileColumns,
} from "../../../../pages/Shoot/pages/Billing/BillingContext"
import ExpenseTable from "../../Common/ExpenseTable/index"
import RoleIdentityComponent from "../../Common/RoleIdentityComponent/index"
import SimpleExpenseTotal from "../../Common/SimpleExpenseTotal/index"

export const CrewDealMemoCard = ({ crewMember = {} }) => {
  const dispatch = useDispatch()

  const [crewMemberState, setCrewMemberState] = useState(crewMember)
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  // *** RESOLVE FLAG  ***

  const setItemToFlag = (nextStatusObj, expenseId) => {
    // args come from handleFlagDialog function, which accesses them from the expense table
    // crewFlagStatus is request - marries the agnostic "comment" from nextStatus to the crew-specific flag comment key
    let crewFlagStatus = {
      crew_flag_status_id: nextStatusObj.crew_flag_status_id,
      crew_flag_comment: nextStatusObj.comment,
    }
    // crewFlagStatus marries the agnostic "comment" from nextStatus object to the crew-specific flag comment key
    dispatch(updateFlagStatusCrewClient(crewFlagStatus, expenseId))
      .then(() => {
        let newStatusString =
          nextStatusObj.crew_flag_status_id === 4 ? "flagged" : "accepted"
        setCrewMemberState(oldState => {
          const newExpenses = oldState.expenses.map(x => {
            if (x.expense_id === expenseId) {
              return {
                ...x,
                crew_flag_status: newStatusString,
                crew_flag_comment: crewFlagStatus.crew_flag_comment,
              }
            } else {
              return x
            }
          })
          return { ...oldState, expenses: newExpenses }
        })
        dispatch(
          openSnackBar({
            message:
              newStatusString === "flagged"
                ? "Expense item flagged"
                : "Flag removed successfully",
          })
        )
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Flag update was unsuccessful" }))
      })
  }

  const handleFlagDialog = (nextStatus, item, user) => {
    // args come from Expense Table handleFlag fn, not from within this file
    const data = {
      flagFunc: setItemToFlag,
      nextStatus: nextStatus,
      comment: item.crew_flag_comment,
      funcParams: [item.expense_id],
    }
    Object.keys(user).length > 0
      ? dispatch(toggleFlaggingDialog(true, data))
      : dispatch(_toggleLoginDialog(true))
  }

  // *** RESOLVE FLAG END  ***

  return (
    <Card style={{ padding: "20px" }}>
      <CardContent>
        <Box
          display="flex"
          flexDirection={viewportWidth > 600 ? "row" : "column"}
          justifyContent={viewportWidth > 600 ? "space-between" : "flex-start"}
          alignItems={viewportWidth > 600 ? "center" : "flex-start"}
        >
          <RoleIdentityComponent role={crewMemberState} showAvatar crewFacing />
          <Typography
            variant={viewportWidth > 600 ? "subtitle1" : "body1"}
            style={
              viewportWidth > 600 ? {} : { color: "#9a9a9a", marginTop: "10px" }
            }
          >
            {/* other statuses being handled in the CrewDealMemoActions right side component */}
            {crewMember.user_status === "sent" &&
              `Sent on ${moment(crewMember.requested_date_time).format(
                "M/D/YY[ @ ]h:mm A"
              )}`}
          </Typography>
        </Box>
        <Box mt={3} mb={3}>
          <ExpenseTable
            columns={viewportWidth > 600 ? columns : crewMobileColumns}
            data={crewMemberState}
          >
            <ExpenseTable.Header />
            <ExpenseTable.ItemsGroup>
              <ExpenseTable.ItemBar>
                <ExpenseTable.NameItem
                  style={
                    viewportWidth < 600
                      ? {
                          gridColumn: "1/ span 6",
                        }
                      : {}
                  }
                />
                {viewportWidth > 600 ? (
                  <ExpenseTable.NumberItem valueForProperty="quantity" />
                ) : (
                  <Box>
                    <Typography
                      style={{
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "#9A9A9A",
                        textAlign: "center",
                      }}
                    >
                      Qty
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="quantity" />
                  </Box>
                )}
                {viewportWidth > 600 ? (
                  <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                ) : (
                  <Box>
                    <Typography
                      style={{
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "#9A9A9A",
                        textAlign: "center",
                      }}
                    >
                      Rate($)
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                  </Box>
                )}
                {viewportWidth > 600 ? (
                  <ExpenseTable.TotalItem>
                    {values =>
                      (values.actual_rate * values.quantity).toFixed(2)
                    }
                  </ExpenseTable.TotalItem>
                ) : (
                  <Box>
                    <Typography
                      style={{
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "#9A9A9A",
                        textAlign: "center",
                      }}
                    >
                      Total($)
                    </Typography>
                    <ExpenseTable.TotalItem justifyContent="center">
                      {values =>
                        (values.actual_rate * values.quantity).toFixed(2)
                      }
                    </ExpenseTable.TotalItem>
                  </Box>
                )}
                <ExpenseTable.Item
                  valueForProperty="description"
                  style={
                    viewportWidth > 600
                      ? {
                          gridColumn: "type_name-start / quantity-start",
                          gridRow: "2/2",
                        }
                      : {
                          gridRow: "2/3",
                          gridColumn: "1/ span 6",
                        }
                  }
                />
                <ExpenseTable.FlagButton onClick={handleFlagDialog} crewView />
              </ExpenseTable.ItemBar>
            </ExpenseTable.ItemsGroup>
          </ExpenseTable>
          <SimpleExpenseTotal data={[crewMember]} />
        </Box>
      </CardContent>
    </Card>
  )
}

CrewDealMemoCard.propTypes = {
  crewMember: PropTypes.object,
}

export default CrewDealMemoCard
